'use strict';

import angular from 'angular';

function OauthResource($resource) {
  return $resource('/api/oauth/:controller', {}, {
    authorize: {
      method: 'POST',
      params: { controller: 'authorize' }
    },
    authorizeLogin: {
      method: 'POST',
      params: { controller: 'authorizelogin' }
    },
    getUser: {
      method: 'GET',
      params: { controller: 'user' }
    },
    checkOk: {
      method: 'GET',
      params: { controller: 'ok' }
    },
    setOk: {
      method: 'POST',
      params: { controller: 'ok' }
    }

  });
}

OauthResource.$inject = ['$resource'];

export default angular.module('georgeApp.oauthSvc', [])
  .factory('OauthSvc', OauthResource)
  .name;
